export function wrap_multiple_widget_areas() {
  if (!$('.nsgk-old').length || !$('.widgets+.widgets').length)
    return;

  $('.widgets').wrapAll('<div class="multiple-widget-area"></div>')
}

export function wrap_woocommerce_shop_elements() {
  if (!$('body').hasClass('woocommerce') || !$('#primary +.widgets.woocommerce').length)
    return;

  $('.widgets.woocommerce, #primary').wrapAll('<div class="old-nsgk-woocommerce"></div>')
}
